<template>
  <fieldset class="uk-fieldset uk-margin">
    <legend class="uk-legend" v-if="hasLegend">
      <slot name="legend">
        {{legend}}
      </slot>
    </legend>
    <slot />
  </fieldset>
</template>

<script>
export default {
  name: 'form-fieldset',
  props: {
    legend: String,
  },
  computed: {
    hasLegend() {
      return this.legend || this.$slots.legend;
    },
  },
};
</script>



// WEBPACK FOOTER //
// FormFieldset.vue?e9a346e2